import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setAuthTokenGetter } from '@/lib/http';

/**
 * Registers Clerk's getToken with the http client so API requests
 * automatically receive an `Authorization: Bearer <jwt>` header.
 */
export function ClerkTokenBridge(): null {
  const { getToken } = useAuth();

  useEffect(() => {
    const getter = (): Promise<string | null> => getToken();
    setAuthTokenGetter(getter);
    return (): void => {
      setAuthTokenGetter(null);
    };
  }, [getToken]);

  return null;
}
